var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7212 6.57505C15.4366 6.57505 16.8273 5.18437 16.8273 3.46889C16.8273 1.75341 15.4366 0.362732 13.7212 0.362732C12.0057 0.362732 10.6151 1.75341 10.6151 3.46889C10.6151 5.18437 12.0057 6.57505 13.7212 6.57505Z",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7212 7.75497C10.7277 7.75497 12.9248 8.64717 12.9248 10.4233L12.9248 12.6373H19.1538V10.9945C19.1538 9.21841 16.6898 7.75497 13.7171 7.75497H13.7212Z",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79947 6.57505C7.51493 6.57505 8.90558 5.18437 8.90558 3.46889C8.90558 1.75341 7.51493 0.362732 5.79947 0.362732C4.08401 0.362732 2.69335 1.75341 2.69335 3.46889C2.69335 5.18437 4.08401 6.57505 5.79947 6.57505Z",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79947 7.75497C2.80592 7.75497 0.362724 9.21841 0.362724 10.9945V12.6373H11.232V10.9945C11.232 9.21841 8.768 7.75497 5.7953 7.75497H5.79947Z",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5989,
    height: 13,
    fill: "white",
    transform: "translate(7.92177)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5989,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupEmpty);
export default __webpack_public_path__ + "static/media/Group_empty.57a9ddc6e7a0b68684c0931ce3d876f2.svg";
export { ForwardRef as ReactComponent };